export enum CollectionName {
    FOOD_TRUCK = 'foodtruck',
    CUISINE_TYPE = 'cuisineType'
}